import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
    range?: string
  }
  start: string
  end: string
  offset: number
  timeZone: string
}

export default function useGetHistogramData({enabled, filter, start, end, offset, timeZone}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_PERSONALIZED_COUNTING_WITH_AVERAGE, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getHistogramFaces({filter, start, end, offset, timeZone})).data.data,
  })

  return query
}
